<template>
  <div class="container-fluid mt-2">
    <h2>Artikelstammdaten</h2>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <div class="btn-group">
        <button class="btn btn-secondary" @click="prevPage()" id="prev"><font-awesome-icon icon="chevron-left"/></button>
        <button class="btn btn-secondary" @click="nextPage()" id="next"><font-awesome-icon icon="chevron-right"/></button>
      </div>
      <div class="input-group">
        <div class="input-group-prepend">
          <button class="btn btn-secondary"><font-awesome-icon icon="search"/></button>
        </div>
        <input class="form-control" id="search" placeholder="min. 3 Zeichen" @keyup="updateSearch()" v-model="search" type="text"/>
      </div>
      <div v-if="smbenabled" class="btn-group">
        <button @click="showUpload" class="btn btn-outline-primary">Importieren</button>
        <a v-if="smbenabled" href="/trendshop.proxy.web/files/CSVDokumentation.pdf" download><button class="btn btn-outline-secondary">Dokumentation</button></a>
      </div>
    </div>
    <b-table no-local-sorting @sort-changed="updateSort" @row-clicked="open" class="mt-3" striped hover :fields="fields" :items="rows"></b-table>
    <b-modal title="Daten importieren" id="smbUpload" @ok="uploadData">
      <div class="input-group">
        <div class="input-group-prepend">
          <button class="input-group-text">Artikel</button>
        </div>
          <input class="form-control" type="file" id="datafile"/>
      </div>
      <span class="text-muted">CSV Datei mit den aktuellen Artikeldaten</span>
      <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">Bilder</span>
          </div>
          <input class="form-control" type="file" id="imgfile"/>
      </div>
      <span class="text-muted">ZIP Archiv mit allen neuen Bildern</span>
      <div class="row" v-show="uploading">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
    </b-modal>
  </div>
</template>

<script>
import router from '@/router';
import config from '@/modules/config.js'
import articles from '@/modules/articles.js'

export default {
  name: 'ArticleList',
  components: {
  },
  data() {
    return {
      rows: [],
      fields: [
        { key: 'map_id', label: 'Artikel-ID', sortable: true },
        { key: 'article_nr', label: 'Artikel-Nr', sortable: true },
        { key: 'desc.short_des', label: 'Beschreibung', sortable: true },
        { key: 'stock', label: 'Lager', sortable: true },
        { key: 'barcode', label: 'Barcode' }
      ],
      search:"",
      smbenabled: false,
      uploading: false,
    }
  },
  created: function() {
    this.fetchData();
    var self = this;
    config.checkSmbEnabled(this,function(data) {
      console.log(data);
      self.smbenabled = data;
    });
  },
  methods: {
    showUpload() {
      this.$bvModal.show('smbUpload');
    },
    updateSort: function(data) {
      var sort = data.sortBy;
      if (sort == 'desc.short_des') sort = 'des';
      articles.viewparams.sdir = (data.sortDesc ? 'desc' : 'asc');
      articles.viewparams.sort = sort;
      this.fetchData();
    },
    open: function(row) {
      router.push({name: 'ArticleView',params:{articleid:row.map_id}});
    },
    fetchData: function() {
      var self = this;
      articles.list(this,function(data) {
        self.rows = data.result;
      })
    },
    prevPage: function() {
      if (articles.viewparams.start > 0) {
        articles.viewparams.start -= articles.viewparams.count;
        this.fetchData();
      }
    },
    nextPage: function() {
      if (this.rows.length > 0) {
        articles.viewparams.start += articles.viewparams.count;
        this.fetchData();
      }
    },
    updateSearch: function() {
      if (this.search.length > 2 || this.search.length == 0){
        articles.viewparams.value = this.search;
        this.fetchData();
      }
    },
    uploadData() {
      var self = this;

      console.log('upload data');

      var file   = document.getElementById('datafile');
      var images = document.getElementById('imgfile');

      // check for csv article data upload
      if (file.files.length > 0) {

        this.uploading = true;

        var fd   = new FormData();
        fd.append("filename",file.files[0]);
        config.post(this,config.baseUrl + 'rest/smallbusiness/article','Artikeldaten import',fd,function(data) {
          console.log(data);
          self.$bvModal.hide('smbUpload');
          self.uploading = false;
          self.$bvToast.toast('Upload abgeschlossen.',{variant: 'success', title: 'Artikeldaten'});
        });
      }

      if (images.files.length > 0) {
        this.uploading = true;
        var fdi = new FormData();
        fdi.append("filename",images.files[0]);
        config.post(this,config.baseUrl + 'rest/smallbusiness/image','Artikelbilder importieren',fdi,function(data) {
          console.log(data);
          self.$bvModal.hide('smbUpload');
          self.uploading = false;
          self.$bvToast.toast('Upload abgeschlossen.',{variant: 'success', title: 'Artikeldaten'});
        });
      }
    },
  }
}
</script>
